import './MapLayout.scss';

import NavBar from '../ui-components/NavBar/NavBar';
import PropTypes from 'prop-types';
import React from 'react';

class MapLayout extends React.Component {
  render () {
    const { children } = this.props;

    return (
      <div className='map-layout--root'>
        <NavBar />
        <div className='map-layout--components'>{children}</div>
      </div>
    );
  }
}

MapLayout.propTypes = {
  children: PropTypes.node
};

export default MapLayout;
